export const DOMAIN = 'consentConfigDetails.configuration.disclosures';
